<template>
  <div>
    <div class="d-flex flex-column flex-xl-row">
      <div class="calendar-wrapper pb-3 pr-xl-3">
        <a class="calendar-icon" :href="getEventUrl()" target="_blank" @click="handleEventClick">
          <calendar-icon
            :month-text="formattedEventData.calendarMonthText"
            :day-text="formattedEventData.calendarDayText"
          />
        </a>
      </div>
      <div>
        <a class="event-title" :href="getEventUrl()" target="_blank" @click="handleEventClick">
          {{ formattedEventData.title }}
        </a>
        <div>{{ formattedEventData.eventDescriptionText }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import CalendarIcon from "./CalendarIcon";
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";
import moment from "moment";

export default {
  name: "event-card",
  mixins: [HomebaseMixpanelMixin],
  props: ["eventData"],
  components: {
    CalendarIcon,
  },
  data() {
    return {
      formattedEventData: null,

      // event meta data
      startDate: "",
      endDate: "",
      isAllDay: false
    };
  },
  created() {
    this.initializeEvent();
  },
  methods: {
    initializeEvent() {
      let e = this.eventData;

      const startDateStr = e.startDate;
      const endDateStr = e.endDate;
      this.setEventDates(startDateStr, endDateStr, e.isAllDay);
      const calendarConfig = this.getCalendarConfig();
      
      this.formattedEventData = {
        id: e.hitId,
        title: e.title,
        calendarMonthText: calendarConfig.calendarMonthText,
        calendarDayText: calendarConfig.calendarDayText,
        eventDescriptionText: calendarConfig.eventDescriptionText,
      };
    },

    setEventDates(startDateStr, endDateStr, isAllDayEvent) {
      this.startDate = moment.utc(startDateStr);
      this.endDate = moment.utc(endDateStr);
      this.isAllDay = isAllDayEvent;
    },

    getCalendarConfig() {
      let res = {};

      let eventStartDate = this.isAllDay ? this.startDate : this.startDate.local();
      let eventEndDate = this.isAllDay ? this.endDate : this.endDate.local();

      const startMonth = eventStartDate.format("MMM");
      const endMonth = eventEndDate.format("MMM");
      const isMultiMonth = startMonth != endMonth;

      const startDay = eventStartDate.date();
      const endDay = eventEndDate.date();
      const isMultiDay = startDay != endDay;

      // set month text
      res.calendarMonthText = isMultiMonth
        ? `${startMonth} - ${endMonth}`
        : startMonth;

      // set day text
      if (isMultiMonth) {
        res.calendarDayText = `${eventStartDate.format(
          "M/D"
        )} - ${eventEndDate.format("M/D")}`;
        res.calendarDayText = this.createHtmlString(
          res.calendarDayText,
          "calendar-text-sm"
        );
      } else if (isMultiDay) {
        res.calendarDayText = `${startDay} - ${endDay}`;
        res.calendarDayText = this.createHtmlString(
          res.calendarDayText,
          "calendar-text-sm"
        );
      } else {
        res.calendarDayText = startDay;
        res.calendarDayText = this.createHtmlString(
          res.calendarDayText,
          "calendar-text-sm"
        );
      }

      // set description text
      if (!isMultiDay) {
        res.eventDescriptionText = this.isAllDay ? `${eventStartDate.format("ddd MMM D")}`: eventStartDate.format("ddd MMM D, h:mm A");
      } else {
        res.eventDescriptionText = `${eventStartDate.format("ddd MMM D")} to ${eventEndDate.format("ddd MMM D")}`;
      }

      return res;
    },

    createHtmlString(inputString, wrapperClass) {
      return `<div class="${wrapperClass}">${inputString}</div>`;
    },

    handleEventClick() {
      let title = this.eventData.title;
      let url = this.getEventUrl();
      let subEvent = `${title} - ${url}`;
      this.trackCalendarEventClick(subEvent);
    },

    getEventUrl() {
      let url = this.eventData.url;
      return url;
    }
  },
};
</script>

<style scoped>
.event-title {
  font-size: 16px !important;
  font-family: artifaktElementBold !important;
}

.event-title,
.calendar-icon {
  color: black !important;
  text-decoration: none !important;
}

.event-title:hover,
.calendar-icon:hover {
  cursor: pointer;
}
/* styles for dynamic calendar font sizes */
.calendar-wrapper >>> .calendar-text-sm {
  font-size: 9px;
}
.calendar-wrapper >>> .calendar-text-md {
  font-size: 14px;
}
.calendar-wrapper >>> .calendar-text-lg {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/homebase/events/EventCard.vue